import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Home, Mountain, Search } from "lucide-react";
import { AccountMenu } from "./AccountMenu";
import { SearchDialog } from "./SearchDialog";
import { MayaMark } from "./BrandLockup";
import { useActiveLang } from "@/hooks/use-active-lang";

/** Navegación principal de escritorio en el encabezado (reemplaza la barra inferior). */
export function DesktopHeaderNav({ compactHome = false }: { compactHome?: boolean }) {
  const { t } = useTranslation();
  const lang = useActiveLang();
  const labels = { es: ["Destinos", "Guías de Maya"], en: ["Destinations", "Maya guides"], fr: ["Destinations", "Guides Maya"], it: ["Destinazioni", "Guide Maya"], de: ["Reiseziele", "Maya-Guides"], pt: ["Destinos", "Guias da Maya"] }[lang];
  const [searchOpen, setSearchOpen] = useState(false);
  const item = "inline-flex h-10 items-center gap-2 rounded-full px-3.5 text-sm font-medium text-foreground/80 transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";
  return (
    <nav aria-label={t("nav.bottom.aria", "Navegación principal")} className="hidden items-center gap-1 lg:flex">
      {compactHome ? <Link to="/explora" className={item}>{labels[0]}</Link> : <Link to="/" className={item} activeOptions={{ exact: true }} activeProps={{ className: "!text-primary" }}>
        <Home className="h-4 w-4" /> {t("nav.bottom.home", "Inicio")}
      </Link>}
      <Link to="/tours" className={item} activeProps={{ className: "!text-primary" }}>
        <Mountain className="h-4 w-4" /> {t("nav.tours", "Tours")}
      </Link>
      {compactHome ? <Link to="/maya" className={item}>{labels[1]}</Link> : <><button type="button" className={item} onClick={() => setSearchOpen(true)}>
        <Search className="h-4 w-4" /> {t("nav.bottom.search", "Buscar")}
      </button></>}
      {!compactHome && <button type="button" className={item} onClick={() => window.dispatchEvent(new CustomEvent("concierge:open"))}>
        <MayaMark size={26} /> Maya
      </button>}
      <AccountMenu
        triggerClassName={item}
        label={<span>{t("nav.bottom.profile", "Perfil")}</span>}
      />
      <SearchDialog open={searchOpen} onOpenChange={setSearchOpen} />
    </nav>
  );
}
